import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  DownloadButton,
  downloadReport
} from '../../elements/ReportDownload'

import { cardStyles as styles } from './index';

const MissingTitlesBySellerReport = ({ data }) => {
  const [sellerId, setSellerId] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'missing-titles-by-seller-report',
      params: { 'seller-id': sellerId }
    })
  }

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Missing Titles By Seller Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <select style={styles.select} onChange={(e) => setSellerId(e.target.value)}>
        <option key="seller-nil" value="">Select Seller</option>
        {data.sellers?.map(seller => (
          <option key={seller.id} value={seller.id}>
            {seller.fullDisplayName}
          </option>
        ))}
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
};

export default MissingTitlesBySellerReport;
